module.exports = __webpack_public_path__ + "img/30.ee4557a5.jpg";